import React from 'react';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/DropdownList';
import DatePicker from '../../DataComponent/DataComponent__DatePicker';
import moment from 'moment';
import config from '../../../config';
import { statisticsByReferral } from '../../../config';
import TooltipNew from '../../TooltipNew';

export class StatisticsByReferralFilter extends React.Component {
    constructor(props) {
        super();

        this.normalizeCount = this.normalizeCount.bind(this);
        this.state = {
            startDate: props.startDate,
            endDate: props.endDate,
            bindActions: props.bindActions,
            groupBy: props.groupBy,
            count: this.normalizeCount(props.count)
        };

        this.onGroupParamChange = this.onGroupParamChange.bind(this);
        this.onCountParamChange = this.onCountParamChange.bind(this);
        this.onBindActionsChange = this.onBindActionsChange.bind(this);
        this.onDataPickerApply = this.onDataPickerApply.bind(this);
    }

    componentDidMount() {
        this.onAction();
    }

    normalizeCount(value) {
        return value === undefined || value === null || value === '' ? value : Number(value);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            startDate: nextProps.startDate,
            endDate: nextProps.endDate,
            bindActions: nextProps.bindActions,
            groupBy: nextProps.groupBy,
            count: this.normalizeCount(nextProps.count)
        });
    }

    onGroupParamChange(value) {
        this.setState({
            groupBy: value.value
        }, () => {
            this.onAction();
        });
    }

    onCountParamChange(value) {
        this.setState({
            count: this.normalizeCount(value.value)
        }, () => {
            this.onAction();
        });
    }

    onBindActionsChange(item) {
        this.setState({
            bindActions: item.value
        }, () => {
            this.onAction();
        });
    }

    onDataPickerApply(datapicker, e) {
        const normalizedStart = datapicker.startDate ? moment(datapicker.startDate).startOf('day') : null;
        const normalizedEnd = datapicker.endDate ? moment(datapicker.endDate).endOf('day') : null;

        this.setState({
            startDate: normalizedStart,
            endDate: normalizedEnd,
        }, () => {
            this.onAction();
        });
    }

    onAction() {
        this.props.onAction(this.state);
    }

    getGroupParams() {
        const translatedParams = this.context?.t?.statisticsByReferral?.groupParams;
        const fallbackParams = (statisticsByReferral && statisticsByReferral.groupParams) || [];

        if (translatedParams && typeof translatedParams === 'object' && !Array.isArray(translatedParams)) {
            return Object.keys(translatedParams).map((key) => ({ title: translatedParams[key], value: key }));
        }

        return fallbackParams.map((key) => ({ title: key, value: key }));
    }

    getCountParams() {
        const params = config.listCounts;
        let listParams = [];

        params.forEach(function(count) {
            listParams.push({title: count, value: count});
        });

        return listParams;
    }

    render() {
        const staticNames = this.context?.t?.reportPage || {};
        const groupParams = this.getGroupParams();
        const countParams = this.getCountParams();

        return (
            <div className="statistics__top form-inline form-horizontal">
                <div className="row table-filter">
                    <div className="table-filter__item">
                        <label>{staticNames.date}:</label>
                        <DatePicker
                            onApply={this.onDataPickerApply}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            className="btn form-control reactdaypicker-block"
                        />
                    </div>
                    <div className="table-filter__item">
                        <label>{this.context?.t?.timezone?.title} <TooltipNew tooltip={this.context?.t?.timezone?.timezoneUnchangeableDueAggregation} /> :</label>
                        <DropdownList
                            className={'rw-dropdownlist-select'}
                            filter='startsWith'
                            valueField='value'
                            textField='title'
                            value={'UTC'}
                            defaultValue={'UTC'}
                            data={[{ value: 'UTC', title: 'UTC' }]}
                            disabled={true}
                        />
                    </div>
                    <div className="table-filter__item">
                        <label>{staticNames.groupBy}:</label>
                        <DropdownList
                            className={'rw-dropdownlist-select'}
                            filter='startsWith'
                            valueField='value'
                            textField='title'
                            value={this.state.groupBy}
                            data={groupParams}
                            onChange={this.onGroupParamChange}
                        />
                    </div>
                    <div className="table-filter__item">
                        <label>{staticNames.count}:</label>
                        <DropdownList
                            className={'rw-dropdownlist-select'}
                            filter='startsWith'
                            valueField='value'
                            textField='title'
                            value={this.state.count}
                            data={countParams}
                            onChange={this.onCountParamChange}
                        />
                    </div>
                </div>
            </div>
        )
    };
}

StatisticsByReferralFilter.propTypes = {};

StatisticsByReferralFilter.defaultProps = {};

StatisticsByReferralFilter.contextTypes = {
    t: PropTypes.object
};

export default StatisticsByReferralFilter;
